"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNav = exports.SrPoliteText = exports.OlStyled = exports.ListStyled = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledNav = exports.StyledNav = _styledComponents["default"].nav.attrs({
  className: 'fuse-pagination'
}).withConfig({
  displayName: "styled-pagination__StyledNav",
  componentId: "sc-qnjyzz-0"
})(["&{display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;@media screen and (max-width:", "){-webkit-box-pack:space-between;-webkit-justify-content:space-between;justify-content:space-between;}}"], _grid.gridConfig.s.maxWidth);
var OlStyled = exports.OlStyled = _styledComponents["default"].ol.attrs({
  className: 'fuse-pagination__page-list',
  'data-testid': 'fuse-pagination__page-list'
}).withConfig({
  displayName: "styled-pagination__OlStyled",
  componentId: "sc-qnjyzz-1"
})(["&{display:inline-flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;}"]);
var ListStyled = exports.ListStyled = _styledComponents["default"].li.attrs({
  className: 'fuse-pagination__list-item',
  'data-testid': 'fuse-pagination__list-item'
}).withConfig({
  displayName: "styled-pagination__ListStyled",
  componentId: "sc-qnjyzz-2"
})(["&{list-style:none;}&:last-child{margin-right:0;}"]);
var SrPoliteText = exports.SrPoliteText = (0, _styledComponents["default"])(_fuseUtils.SrOnly).attrs({
  'aria-live': 'polite'
}).withConfig({
  displayName: "styled-pagination__SrPoliteText",
  componentId: "sc-qnjyzz-3"
})([""]);